import { RouteConfig, SideLink } from '@/types/utility.types'
import {
  IconCalendarUser,
  IconCash,
  IconChartInfographic,
  IconCheckupList,
  IconClock12,
  IconDatabaseDollar,
  IconHistoryToggle,
  IconMapPin,
  IconReport,
  IconTemperatureSun,
  IconTruckDelivery,
  IconUserDollar,
  IconUsersGroup,
} from '@tabler/icons-react'

export const clientOrderPricesModuleKey = 'client_order_prices_report'
export const productHistoryV2ModuleKey = 'product_history_report'
export const materialReportModuleKey = 'material_report'
export const profitReportModuleKey = 'profits_report'
export const mmlReportModuleKey = 'mml_report'
export const mmlSeasonModuleKey = 'mml_season'
export const zakasCycleModuleKey = 'zakas_cycle'
export const debtorsModuleKey = 'debts'
export const userHistoryModuleKey = 'dashboard' //should change after backend finished
export const acquisitionSourceModuleKey = 'acquisition_source'
export const cachierReportModuleKey = 'cachier_report'

const clientOrderPricesRoute: RouteConfig = {
  uid: clientOrderPricesModuleKey,
  path: '/reports/client-order-prices',
  type: 'list',
  lazy: async () => ({
    Component: (await import('@/pages/reports/client-order-prices')).default,
  }),
}

const productHistoryV2Route: RouteConfig = {
  uid: productHistoryV2ModuleKey,
  path: '/reports/product-history-v2',
  type: 'list',
  lazy: async () => ({
    Component: (await import('@/pages/reports/product-history-v2')).default,
  }),
}

const materialReportV3Route: RouteConfig = {
  uid: materialReportModuleKey,
  path: '/reports/material-report-v3',
  type: 'list',
  lazy: async () => ({
    Component: (await import('@/pages/reports/material-report-v3')).default,
  }),
}

const profitReportRoute: RouteConfig = {
  uid: profitReportModuleKey,
  path: '/reports/profit-report',
  type: 'list',
  lazy: async () => ({
    Component: (await import('@/pages/reports/profit-report')).default,
  }),
}

const mmlReportV4Route: RouteConfig = {
  uid: mmlReportModuleKey,
  path: '/reports/mml-report-v4',
  type: 'list',
  lazy: async () => ({
    Component: (await import('@/pages/reports/mml-report-v4')).default,
  }),
}

const mmlSeasonRoute: RouteConfig = {
  uid: mmlSeasonModuleKey,
  path: '/reports/mml-season',
  type: 'list',
  lazy: async () => ({
    Component: (await import('@/pages/reports/mml-season')).default,
  }),
}

const zakasCycleRoute: RouteConfig = {
  uid: zakasCycleModuleKey,
  path: '/reports/zakas-cycle',
  type: 'list',
  lazy: async () => ({
    Component: (await import('@/pages/reports/zakas-cycle')).default,
  }),
}

const zakasCycleDetailRoute: RouteConfig = {
  uid: zakasCycleModuleKey,
  path: '/reports/zakas-cycle/:id',
  type: 'list',
  lazy: async () => ({
    Component: (await import('@/pages/reports/zakas-cycle/detail')).default,
  }),
}

const zakasCycleReportsRoute: RouteConfig = {
  uid: zakasCycleModuleKey,
  path: '/reports/zakas-cycle-reports',
  type: 'report',
  lazy: async () => ({
    Component: (await import('@/pages/reports/zakas-cycle-reports')).default,
  }),
}

const debtorsRoute: RouteConfig = {
  uid: debtorsModuleKey,
  path: '/reports/debtors',
  type: 'list',
  lazy: async () => ({
    Component: (await import('@/pages/debt/debtors')).default,
  }),
}

const userHistoryRoute: RouteConfig = {
  uid: userHistoryModuleKey,
  path: '/reports/user-history',
  type: 'list',
  lazy: async () => ({
    Component: (await import('@/pages/reports/user-history')).default,
  }),
}

const acquisitionSourceRoute: RouteConfig = {
  uid: acquisitionSourceModuleKey,
  path: '/reports/acquisition-source',
  type: 'list',
  lazy: async () => ({
    Component: (await import('@/pages/reports/acquisition-source')).default,
  }),
}

const cachierReportRoute: RouteConfig = {
  uid: cachierReportModuleKey,
  path: '/reports/cachier-report',
  type: 'list',
  lazy: async () => ({
    Component: (await import('@/pages/reports/cachier-report')).default,
  }),
}

export const sidelink: SideLink = {
  title: 'Reports',
  href: '',
  icon: <IconReport size={18} />,
  order: 2,
  sub: [
    {
      uid: clientOrderPricesModuleKey,
      title: 'Client Order Prices',
      href: '/reports/client-order-prices',
      icon: <IconUserDollar size={18} />,
      order: 1,
    },
    {
      uid: productHistoryV2ModuleKey,
      title: 'product_history_v2',
      href: '/reports/product-history-v2',
      icon: <IconHistoryToggle size={18} />,
      order: 2,
    },
    {
      uid: materialReportModuleKey,
      title: 'material_report_v3',
      href: '/reports/material-report-v3',
      icon: <IconClock12 size={18} />,
      order: 3,
    },
    {
      uid: profitReportModuleKey,
      title: 'profit_report',
      href: '/reports/profit-report',
      icon: <IconDatabaseDollar size={18} />,
      order: 4,
    },
    {
      uid: mmlReportModuleKey,
      title: 'mml_report_v4',
      href: '/reports/mml-report-v4',
      icon: <IconCheckupList size={18} />,
      order: 5,
    },
    {
      uid: mmlSeasonModuleKey,
      title: 'mml_season',
      href: '/reports/mml-season',
      icon: <IconTemperatureSun size={18} />,
      order: 6,
    },
    {
      uid: zakasCycleModuleKey,
      title: 'zakas_cycle',
      href: '/reports/zakas-cycle',
      icon: <IconTruckDelivery size={18} />,
      order: 7,
    },
    {
      uid: zakasCycleModuleKey,
      action: 'report',
      title: 'zakas_cycle_reports',
      href: '/reports/zakas-cycle-reports',
      icon: <IconChartInfographic size={18} />,
      order: 7,
    },
    {
      uid: debtorsModuleKey,
      title: 'debtors',
      href: '/reports/debtors',
      icon: <IconUsersGroup size={18} />,
      order: 8,
    },
    {
      uid: userHistoryModuleKey,
      title: 'user_history',
      href: '/reports/user-history',
      icon: <IconCalendarUser size={18} />,
      order: 9,
    },
    {
      uid: acquisitionSourceModuleKey,
      title: 'acquisition_source',
      href: '/reports/acquisition-source',
      icon: <IconMapPin size={18} />,
      order: 10,
    },
    {
      uid: cachierReportModuleKey,
      title: 'cachier_report',
      href: '/reports/cachier-report',
      icon: <IconCash size={18} />,
      order: 11,
    },
  ],
}

export default [
  clientOrderPricesRoute,
  productHistoryV2Route,
  materialReportV3Route,
  profitReportRoute,
  mmlReportV4Route,
  mmlSeasonRoute,
  zakasCycleRoute,
  zakasCycleDetailRoute,
  zakasCycleReportsRoute,
  debtorsRoute,
  userHistoryRoute,
  acquisitionSourceRoute,
  cachierReportRoute,
]
